// extracted by mini-css-extract-plugin
export default {"paper":"TitleCommitmentSection_paper__hnD2b","textFields":"TitleCommitmentSection_textFields__r3ruw"};